(function () {
  'use strict';

  angular.module('app').component('productCategoryPage', productCategoryDetailComponent());

  function productCategoryDetailComponent() {
    return {
      controller: ProductCategoryDetailCtrl,
      controllerAs: 'vm',
      bindings: {},
      templateUrl: './app/ajs/product-categories/product-category-page.component.html',
    };
  }

  ProductCategoryDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'ProductCategoryService',
    'LanguageService',
  ];

  function ProductCategoryDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    ProductCategoryService,
    LanguageService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_productcategory_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.activeTab = $routeParams.activeTab;

    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    // Initializers
    // getProductCategory();
    getAdditionalLanguages();

    function getProductCategory() {
      if (itemId) {
        // edit
        ProductCategoryService.getProductCategory(itemId, vm.defaultLanguage).then(function (data) {
          vm.item = data;
        });
      } else {
        vm.item = {};
      }
    }

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getProductCategory();
      });
    }

    function onSavedItem(item) {
      $location.path(`/product_categories/${item.id}`);
    }

    function onCanceledItem() {
      $location.path('/product_categories');
    }
  }
})();
